<div class="page-head">
    <app-back (click)="handleBackCLick()"></app-back>
    <div>
        <h1 class="title title--size-l text--center">Transaction View</h1>
    </div>
</div>
<div class="page-content">
    <div class="page-row tx-info" *ngIf="txInfo">
        <div class="tx-state">
            <ng-container *ngIf="txInfo?.state">
                <ng-container [ngSwitch]="txInfo.state">
                    <ng-container *ngSwitchCase="2">
                        <p class="tx-status text--color-secondary">
                            {{
                                "COMMON.STATES.PROCESSING"
                                    | translate
                                    | uppercase
                            }}
                        </p>
                    </ng-container>
                    <ng-container *ngSwitchCase="1">
                        <p class="tx-status text--color-green">
                            {{
                                "COMMON.STATES.SUCCESS" | translate | uppercase
                            }}
                        </p>
                    </ng-container>
                    <ng-container *ngSwitchCase="0">
                        <p class="tx-status success">
                            {{ "COMMON.STATES.FAILED" | translate | uppercase }}
                        </p>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
        <div class="info-entry">
            <div class="heading text--color-secondary text--size-s">
                Transaction id
            </div>
            <div class="value">
                <a
                    target="_blank"
                    [href]="scanLink + '/tx/' + txInfo?.hash"
                    class="link--color-blue hash"
                    >{{ txInfo?.hash }}</a
                >
                <app-copy [value]="txInfo?.hash">
                    <app-copy-icon class="action-image"></app-copy-icon>
                </app-copy>
            </div>
        </div>
        <div class="info-entry">
            <div class="heading text--color-secondary text--size-s">
                Sender address
            </div>
            <div class="value">
                <p class="address">
                    {{ txInfo?.senderAddress }}
                </p>
                <app-copy [value]="txInfo?.senderAddress">
                    <app-copy-icon class="action-image"></app-copy-icon>
                </app-copy>
            </div>
        </div>
        <div class="info-entry">
            <div class="heading text--color-secondary text--size-s">
                Sender address
            </div>
            <div class="value">
                <p class="address">
                    {{ txInfo?.recipientAddress }}
                </p>
                <app-copy [value]="txInfo?.recipientAddress">
                    <app-copy-icon class="action-image"></app-copy-icon>
                </app-copy>
            </div>
        </div>
        <div class="info-entry">
            <div class="heading text--color-secondary text--size-s">
                Network fee
            </div>
            <div class="value">
                <div>
                    <p>
                        {{ txInfo?.gasUsed | number : ".2-8" }}
                        {{ baseCurrency.symbol | uppercase }}
                    </p>
                    <p class="text--color-secondary text--size-s">
                        ~{{ txInfo?.gasUsedUsd | number : ".2-8" }} USD
                    </p>
                </div>
            </div>
        </div>
        <div class="info-entry">
            <div class="heading text--color-secondary text--size-s">
                Confirmations
            </div>
            <div class="value">{{ txInfo?.confirmations }}</div>
        </div>
        <div class="info-entry">
            <div class="heading text--color-secondary text--size-s">
                {{ "WALLET.TX.TIME" | translate }}
            </div>
            <div class="value">{{ txInfo?.dt | date : "medium" }}</div>
        </div>
    </div>
</div>
